var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBottomRightArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0577 7.50004L1.06407 6.21461L5.19639 6.19411L0.546875 1.56837L1.47413 0.641113L6.12364 5.26685L6.14811 1.13057L7.40989 1.12431L7.37843 7.46474L1.05377 7.49612L1.0577 7.50004Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBottomRightArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bottom-right-arrow.6bc8940867a711352ee38518d0d31ccd.svg";